import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: `#005aff`,
          secondary: `#424242`,
          accent: `#ff9800`,
          error: `#f44336`,
          warning: `#ffc107`,
          info: `#607d8b`,
          success: `#4caf50`
        },
      },
      dark: {
        colors: {
          primary: '#005aff',
          secondary: '#424242',
          accent: '#FF4081',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  }
})